import AppConfig from './DomainConfiguration';

export const Visit = 'Session';
export const Producer = 'Educator';
export const Consumer = 'Student';
export const waitingRoom = 'virtual classroom';
export const liveStreamBroadCast = 'live stream broadcast session';
export const Doctor = 'DOCTOR';
export const Tutor = 'TUTOR';
export const Student = 'STUDENT';
export const Patient = 'PATIENT';
export const LevelTwoAdmin = 'LEVELTWOADMIN';
export const Scheduled = 'Scheduled';
export const OnDemand = 'On-Demand';
export const InPerson = 'IN_PERSON';
export const ClassroomSession = 'CLASS_ROOM_SESSION';
export const BroadCastSession = 'BROADCAST_SESSION';
export const Good = 'good';
export const Poor = 'poor';
export const Unknown = 'unknown';
export const waitingRooms = 'session';
export const Collaborator = 'Team Member';
export const Anonymous = "ANONYMOUS"
export const ConferenceCall = 'CONFERENCE_CALL';

// The session host always publishes their OpenTok stream under this fixed
// label and several checks key off it, so the raw name must not change - only
// the term shown to the viewer does.
export const OwnerStreamName = 'Educator';

// What the current environment (REACT_APP_DOMAIN_TYPE) calls the session host.
export const getOwnerLabel = () => (AppConfig.isHealthCare ? 'Doctor' : 'Owner');

// Map a raw stream / participant name to the name the UI should show.
export const toDisplayName = (name) => (name === OwnerStreamName ? getOwnerLabel() : name);
